/**
 * Created by rak on 8/15/2016.
 */
'use strict';
angular.module('trackReporting').controller('DriverWhDatevExportCtrl', function ($scope, commonTrackService, widgetSettingsCreatorService, items, reportService, $filter, $translate, $window, toastService, errorHandlingService, $timeout, $rootScope) {
  var startDate = '';
  $scope.overviewGridPrefix = commonTrackService.getOverviewGridPrefix();
  var endDate = '';
  var source =
  {
    datatype: 'array',
    datafields: [],
    localdata: []
  };
  $scope.alerts = [];
  var dataAdapter;
  var column = [];
  var isInitialLoading = false;
  var gridSettings;
  $scope.moduleName = 'performancereport';
  var dialogModelData = items.dataRange;
  $scope.date = {
    startDate: dialogModelData.startDate || new Date(),
    endDate: dialogModelData.endDate || new Date()
  };
  $scope.workingHoursDatev = {};

  var dateRangeCustomEventHandler = {
    eventHandlers: {
      'apply.daterangepicker': function () {
        startDate = $scope.date.startDate.format('YYYY/MM/DD/HH:mm:ss');
        endDate = $scope.date.endDate.format('YYYY/MM/DD/HH:mm:ss');
        loadRport();
      }
    }
  };
  $scope.options = commonTrackService.getDateRangePickerSettings(dateRangeCustomEventHandler);

  $scope.workingHoursDatev.driverComboSettings = items.driverOptionSetting;
  $scope.workingHoursDatev.driverComboSettings.checkboxes = true;
  $scope.workingHoursDatev.driverComboSettings.autoComplete = false;
  if ($scope.workingHoursDatev.driverComboSettings.source[0].key !== 'selectAll') {
    $scope.workingHoursDatev.driverComboSettings.source.unshift({
      displayName: $translate.instant('additionalTranslation.comboboxOptionALL'),
      key: 'selectAll'
    });
  }

  $scope.workingHoursDatev.driverComboSettings.multiSelect = true;


  function setSelectedVehicles(item) {
    $timeout(function () {
      $('#driverComboBoxDateEvDialog').jqxComboBox('checkItem', item.value);
    }, 100);
  }

  function hasAllOptionInSelectedList() {
    var selectedDrivers = $('#driverComboBoxDateEvDialog').jqxComboBox('getCheckedItems');
    var isAllFound = false;
    for (var i = 0; i < selectedDrivers.length; i++) {
      if (selectedDrivers[i].value === 'selectAll') {
        isAllFound = true;
        break;
      }
    }
    return isAllFound;
  }

  $timeout(function () {
    $('#driverComboBoxDateEvDialog').on('checkChange', checkChangeEvent);
  });
  var loadRport = function (driverIdsFromLoadCall) {
    $scope.date.startDate = moment($scope.date.startDate);
    $scope.date.endDate = moment($scope.date.endDate);
    startDate = $filter('date')($scope.date.startDate._d, 'yyyy/MM/dd/HH:mm:ss');
    endDate = $filter('date')($scope.date.endDate._d, 'yyyy/MM/dd/HH:mm:ss');
    var driverIds = {
      driverID: []
    };

    driverIds.driverID = driverIdsFromLoadCall && driverIdsFromLoadCall.length > 0 || isInitialLoading ? driverIdsFromLoadCall : _getDriverIds(hasAllOptionInSelectedList());

    reportService.getVehilceReport($scope.moduleName, items.deviceId, endDate, startDate, true, 'DriverWorkingHoursDatev', null, driverIds).then(function (datevRepotList) {

      source.localdata = datevRepotList.dataList;
      column = commonTrackService.getColumnProperties(datevRepotList.gridSettings.overviewListGrids[0].columnProperties, datevRepotList.columnTranslation, {
        moduleName: 'DriverWorkingHoursDatev',
        reportModel: 'driverWorkingHrsDatevReport'
      });
      var _additionalProperties = {
        translatedName: $translate.instant('trackReporting.performanceReport.customExportDialog.title'),
        isDynamicGrid: true,
        dynamicModuleName: 'DriverWorkingHoursDatev'
      };
      gridSettings = commonTrackService.getGridSettings('driverWorkingHrsDatevReport', {
        pagesizeoptions: ['10', '15', '25'],
        pagesize: 10,
        columns: column,
        autosavestate: false,
        height: 360,
        autoloadstate: false
      }, null, _additionalProperties);
      dataAdapter = new $.jqx.dataAdapter(source);
      gridSettings.source = dataAdapter;
      //$('#'+$scope.overviewGridPrefix+'driverWorkingHrsDatevReportList').jqxGrid({columns: column});
      $('#' + $scope.overviewGridPrefix + 'driverWorkingHrsDatevReportList').jqxGrid(gridSettings);

    }, function () {
    }).finally(function () {

      $scope.dataLoadingFinished = true;
      $scope.initSelectionFinished = true;
      //column = null;
    });
  };

  $scope.exportDatev = function () {
    $scope.date.startDate = moment($scope.date.startDate);
    $scope.date.endDate = moment($scope.date.endDate);
    startDate = $filter('date')($scope.date.startDate._d, 'yyyy/MM/dd/HH:mm:ss');
    endDate = $filter('date')($scope.date.endDate._d, 'yyyy/MM/dd/HH:mm:ss');

    var driverIds = {
      driverID: _getDriverIds(hasAllOptionInSelectedList())
    };

    reportService.driverWrkHrsDatevVtmDownload($scope.moduleName, items.deviceId, endDate, startDate, true, 'DriverWorkingHoursDatev', null, driverIds).then(function (result) {
      var blob = new $window.Blob([result]);
      saveAs(blob, $filter('date')($scope.date.endDate._d, 'MMyyyy') + '.vtm');
      return reportService.driverWrkHrsDatevExcelDownload($scope.moduleName, items.deviceId, endDate, startDate, true, 'DriverWorkingHoursDatev', null, driverIds).then(function (result) {
        var blob2 = new $window.Blob([result]);
        saveAs(blob2, $filter('date')($scope.date.endDate._d, 'ddMMyyyy') + '.xls');
        toastService.showSuccessToast($translate.instant('trackReporting.performanceReport.customExportDialog.exportSuccess'));
      }, function (response) {
        errorHandlingService.handleForCommonResponse(response);
      }
      );
    }, function (response) {
      errorHandlingService.handleForCommonResponse(response);
    });
  };


  $scope.cancel = function () {
    $scope.$dismiss('cancel');
  };

  $scope.closeAlertByIndex = function (index) {
    $scope.alerts.splice(index, 1);
  };


  $scope.getReport = function () {
    loadRport(_getDriverIds(hasAllOptionInSelectedList()));

  };

  var updateDateRangeInternalDateEvent = $scope.$on('date-range-internalDate-old', function () {
    $scope.options.ranges = commonTrackService.setDateRangePickerCustomOptions($scope.options);
  });

  var clearFilterevnt = $rootScope.$on('combobox-clear-selection-evt', function (event, data) {
    if (data.id === 'driverComboBoxDateEvDialog') {
      isAllUncheck = true;
      _checkOrUncheckItem('uncheckItem');
      isAllUncheck = false;
      loadRport([]);
    }
  });


  if (items.selctedOption.length > 0 && items.selctedOption[0].value !== 'selectAll') {
    isInitialLoading = true;
    var initialSelectedDriverId = [];
    for (var i = 0; i < items.selctedOption.length; i++) {
      setSelectedVehicles(items.selctedOption[i]);
      initialSelectedDriverId.push(items.selctedOption[i].value);
    }
    loadRport(initialSelectedDriverId);
    isInitialLoading = false;
  } else {
    isInitialLoading = true;
    loadRport([]);
    isInitialLoading = false;
  }

  $scope.$on('$destroy', function () {
    clearFilterevnt();
    updateDateRangeInternalDateEvent();
  });

  function _checkOrUncheckItem(operation) {
    for (var k = 0; k < $scope.workingHoursDatev.driverComboSettings.source.length; k++) {
      $('#driverComboBoxDateEvDialog').jqxComboBox(operation, $scope.workingHoursDatev.driverComboSettings.source[k].key);
    }
  }

  var isSelectAll = false;
  var isAllUncheck = false;

  function _getDriverIds(isAll, forceUnselect) {
    var driverArr = [];
    if (!isAll) {
      var selectedDrivers = $('#driverComboBoxDateEvDialog').jqxComboBox('getCheckedItems');
      for (var i = 0; i < selectedDrivers.length; i++) {
        if (selectedDrivers[i].value !== 'selectAll') {
          driverArr.push(selectedDrivers[i].value);
        } else {
          if (forceUnselect) {
            isAllUncheck = true;
            $('#driverComboBoxDateEvDialog').jqxComboBox('uncheckItem', 'selectAll');
            isAllUncheck = false;
          }

        }
      }
      return driverArr;
    } else {
      for (var j = 0; j < $scope.workingHoursDatev.driverComboSettings.source.length; j++) {
        if ($scope.workingHoursDatev.driverComboSettings.source[j].key !== 'selectAll') {
          driverArr.push($scope.workingHoursDatev.driverComboSettings.source[j].key);
        }
      }
      return driverArr;
    }

  }

  function checkChangeEvent(event) {
    if (event.args && event.args.item) {
      if (isAllUncheck || isSelectAll) {
        return;
      }
      try {
        if (event.args.item.value === 'selectAll' && event.args.checked === true) {
          isSelectAll = true;
          $('#driverComboBoxDateEvDialog').jqxComboBox('clearSelection');
          _checkOrUncheckItem('checkItem');
          isSelectAll = false;
          return;
        }
        else if (event.args.item.value === 'selectAll' && event.args.checked === false) {
          isAllUncheck = true;
          _checkOrUncheckItem('uncheckItem');
          isAllUncheck = false;
          return;
        }
      } finally {
        loadRport();
      }
    }
  }

});



// WEBPACK FOOTER //
// ./.tmp/components/track/reports/workingHoursDatevDialogController.js